export const LOGIN = 'login';
export const OAUTH = 'oauth';



// WEBPACK FOOTER //
// ./app/constants/route.js